import { Collapse, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useVictimsAndKillers } from "../../../hooks/useVictimsAndKillers";
import { useSpotifySearchLink } from "../../../hooks/useSpotifySearchLink";
import { SerialKillerDetailRows } from "./SerialKillerDetailRows";
import { WikipediaLink } from "components/shared/WikipediaLink";
import { SpotifyLink } from "components/shared/SpotifyLink";
import styled from "styled-components";

const SpinIcon = styled(LoadingOutlined)`
  font-size: 24px;
  color: #8e1616;
`;

const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
`;

// Styled components
const KillerCollapse = styled(Collapse)`
  width: 100%;
  border-radius: 8px;

  /* Panel container and header/content colors */
  .ant-collapse-item {
    background: #393e46;
    color: #eeeeee;

    border-radius: 8px;
    overflow: hidden;
  }

  .ant-collapse-header {
    background: #393e46;
    color: #eeeeee;
    padding: 8px 16px !important;
    border-bottom: 1px solid #222831;
    border-radius: 8px;
  }
  .ant-collapse-header .ant-collapse-header-text {
    color: #eeeeee;
    width: 100%;
  }
  .ant-collapse-expand-icon .anticon svg {
    fill: #eeeeee;
    color: #eeeeee;
  }

  .ant-collapse-content {
    background: #393e46;
    color: #eeeeee;
    border-top: 1px solid #222831;
    border-radius: 0 0 8px 8px;
  }
  .ant-collapse-content-box {
    padding: 12px 16px !important;
    color: #eeeeee;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const HeaderLinks = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center; /* center vertically and horizontally within its inline-flex */
  gap: 8px;
`;

export default function SerialKillerDetailsCollapse({
  killerId,
}: {
  killerId: string;
}) {
  const { serialKillerById, serialKillerLoadingById } = useVictimsAndKillers();
  const killer = serialKillerById[killerId];
  const loading = !!serialKillerLoadingById[killerId];

  // const searchName =
  //   (killer?.alias && killer.alias.trim() ? killer.alias : killer?.name) ??
  //   null;
  // const { url: spotifyUrl } = useSpotifySearchLink(searchName, null);

  const header = (
    <HeaderRow>
      <span>Serial killer details</span>
      <HeaderLinks>
        {killer?.wikipediaLink && <WikipediaLink href={killer.wikipediaLink} />}
        {/* {spotifyUrl && <SpotifyLink href={spotifyUrl} />} */}
      </HeaderLinks>
    </HeaderRow>
  );

  return (
    <KillerCollapse
      defaultActiveKey={[]}
      items={[
        {
          key: "details",
          label: header,
          children: loading ? (
            <SpinWrapper>
              <Spin indicator={<SpinIcon spin />} />
            </SpinWrapper>
          ) : killer ? (
            <SerialKillerDetailRows killer={killer} />
          ) : (
            "No details"
          ),
        },
      ]}
    />
  );
}
